import { css } from 'styled-components';
import { PALETTE, Z_INDEX } from '~/assets/styles/base';

/**
 * antdのTimePicker用のCSS。
 * コンポーネント内に閉じれないのでグローバル定義する。
 */
const defaultStyle = css`
  .ant-picker-time-panel-column
    > li.ant-picker-time-panel-cell-selected
    .ant-picker-time-panel-cell-inner {
    background: ${PALETTE.primary.main};
    color: #fff;
  }
  .ant-picker-ranges {
    text-align: center;
    & .ant-picker-ok {
      float: none;
      margin: 0 auto;
      & .ant-btn-primary {
        border-color: ${PALETTE.primary.main};
        background: ${PALETTE.primary.main};
        border-radius: 4px;
      }
    }
  }

  .ant-picker-dropdown {
    z-index: ${Z_INDEX.max + 1} !important;
  }
`;
export default defaultStyle;
